"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInventoryGoods = exports.updateInventoryCounting = exports.outBound = exports.inventoryTransactions = exports.inventoryList = exports.inBound = exports.getInventoryGoodsSimpleList = exports.getInventoryGoodsList = exports.getInventoryGoodsDetail = exports.getInventoryCountingRecords = exports.getInventoryCountingList = exports.deleteInventoryGoods = exports.deleteInventoryCountingGoods = exports.createInventoryGoods = exports.createInventoryCounting = exports.confirmInventoryCounting = exports.boxSplitting = exports.batchOutBound = exports.batchInBound = exports.batchCreateInventoryGoods = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 仓库相关请求
 * @date 2026-03-30
 */

var GOODS_BASE_URL = '/admin/inventory/goods';
var STOCK_BASE_URL = '/admin/stock';
var COUNTING_BASE_URL = '/admin/stockCheck';

/**
 * @typedef {0|1} status
 * 商品状态：
 * 0 - 停用
 * 1 - 启用
 */
/**
 * 分页查询商品
 * @param {Object} params 查询参数
 * @param {string} [params.barcode] 商品条码
 * @param {string} [params.brand] 商品品牌
 * @param {string} [params.name] 商品名称
 * @param {number} [params.id] 商品ID
 * @param {string} [params.childBarcode] 子商品条码
 * @param {number} [params.childGoodsId] 子级id
 * @param {number} [params.status] 商品状态
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var getInventoryGoodsList = exports.getInventoryGoodsList = function getInventoryGoodsList(params) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/list"),
    method: 'GET',
    params: params
  });
};

/**
 * 查询商品详情
 * @param {number} id 商品ID
 * @returns {Promise<object>}
 */
var getInventoryGoodsDetail = exports.getInventoryGoodsDetail = function getInventoryGoodsDetail(id) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/info?id=").concat(id),
    method: 'GET'
  });
};

/**
 * 商品快速搜索
 * @param {string} [keyword] 搜索关键字
 * @param {number} [limit] 返回条数限制，默认 20，最大 50，前端设置默认50
 * @returns {Promise<object>}
 */
var getInventoryGoodsSimpleList = exports.getInventoryGoodsSimpleList = function getInventoryGoodsSimpleList(keyword) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/simple/list"),
    method: 'GET',
    params: {
      keyword: keyword,
      limit: limit
    }
  });
};

/**
 * 新增商品
 * @param {Object} data 新增商品参数
 * @param {string} data.barcode 商品条码
 * @param {string} data.brand 商品品牌
 * @param {string} data.childBarcode 子商品条码
 * @param {number} data.childGoodsId 子商品ID
 * @param {string} data.convertQty 商品条码
 * @param {string} data.name 商品名称
 * @param {string} data.spec 商品规格
 * @param {number} data.status 商品状态
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var createInventoryGoods = exports.createInventoryGoods = function createInventoryGoods(data) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/save"),
    method: 'POST',
    data: data
  });
};

/**
 * 批量新增商品
 * @param {Array<Object>} goodsList 新增参数
 * @param {string} goodsList[].barcode 商品条码
 * @param {string} goodsList[].brand 商品品牌
 * @param {string} goodsList[].childBarcode 子商品条码
 * @param {number} goodsList[].childGoodsId 子商品ID
 * @param {string} goodsList[].convertQty 商品条码
 * @param {string} goodsList[].name 商品条码
 * @param {string} goodsList[].spec 商品规格
 * @param {string} goodsList[].status 商品状态
 * @param {string} goodsList[].remark 备注信息
 * @returns {Promise<object>}
 */
var batchCreateInventoryGoods = exports.batchCreateInventoryGoods = function batchCreateInventoryGoods(goodsList) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/batch/save"),
    method: 'POST',
    data: {
      goodsList: goodsList
    }
  });
};

/**
 * 修改商品
 * @param {Object} data 修改商品参数
 * @param {number} data.id 商品id
 * @param {string} data.barcode 商品条码
 * @param {string} data.brand 商品品牌
 * @param {string} data.childBarcode 子商品条码
 * @param {number} data.childGoodsId 子商品ID
 * @param {string} data.convertQty 商品条码
 * @param {string} data.name 商品条码
 * @param {string} data.spec 商品规格
 * @param {string} data.status 商品状态
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var updateInventoryGoods = exports.updateInventoryGoods = function updateInventoryGoods(data) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/update"),
    method: 'POST',
    data: data
  });
};

/**
 * 删除商品
 * @param {number} id 商品id
 * @returns {Promise<object>}
 */
var deleteInventoryGoods = exports.deleteInventoryGoods = function deleteInventoryGoods(id) {
  return (0, _request.default)({
    url: "".concat(GOODS_BASE_URL, "/delete?id=").concat(id),
    method: 'GET'
  });
};

/**
 * 执行入库
 * @param {Object} data 入库参数
 * @param {string} data.barcode 商品条码
 * @param {number} data.goodsId 商品ID
 * @param {string} data.name 商品名称
 * @param {string} data.operator 操作人
 * @param {number} data.quantity 操作数量
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var inBound = exports.inBound = function inBound(data) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/in"),
    method: 'POST',
    data: data
  });
};

/**
 * 批量执行入库
 * @param {Array<Object>} itemList 入库参数
 * @param {string} itemList[].barcode 商品条码
 * @param {number} itemList[].goodsId 商品ID
 * @param {string} itemList[].name 商品名称
 * @param {string} itemList[].operator 操作人
 * @param {number} itemList[].quantity 操作数量
 * @param {string} itemList[].remark 备注信息
 * @returns {Promise<object>}
 */
var batchInBound = exports.batchInBound = function batchInBound(itemList) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/batch/in"),
    method: 'POST',
    data: {
      itemList: itemList
    }
  });
};

/**
 * 执行出库
 * @param {Object} data 出库参数
 * @param {string} data.barcode 商品条码
 * @param {number} data.goodsId 商品ID
 * @param {string} data.name 商品名称
 * @param {string} data.operator 操作人
 * @param {number} data.quantity 操作数量
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var outBound = exports.outBound = function outBound(data) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/out"),
    method: 'POST',
    data: data
  });
};

/**
 * 批量执行出库
 * @param {Array<Object>} itemList 出库参数
 * @param {string} itemList[].barcode 商品条码
 * @param {number} itemList[].goodsId 商品ID
 * @param {string} itemList[].name 商品名称
 * @param {number} itemList[].operator 操作人
 * @param {number} itemList[].quantity 操作数量
 * @param {string} itemList[].remark 备注信息
 * @returns {Promise<object>}
 */
var batchOutBound = exports.batchOutBound = function batchOutBound(itemList) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/batch/out"),
    method: 'POST',
    data: {
      itemList: itemList
    }
  });
};

/**
 * 分页查询库存
 * @param {Object} params 查询库存参数
 * @param {string} [params.barcode] 商品条码
 * @param {number} [params.goodsId] 商品ID
 * @param {string} [params.name] 商品名称
 * @param {number} [params.maxStockQty] 最大库存数量
 * @param {number} [params.minStockQty] 最小库存数量
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var inventoryList = exports.inventoryList = function inventoryList(params) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/list"),
    method: 'GET',
    params: params
  });
};

/**
 * @typedef {'IN'|'OUT'|'UNPACK_OUT'|'UNPACK_IN'|'CHECK_ADJUST'} BizType
 * 业务类型：
 * IN - 入库
 * OUT - 出库
 * UNPACK_OUT - 拆箱出库
 * UNPACK_IN - 拆箱单品入库
 * CHECK_ADJUST - 盘库库存调整
 */
/**
 * 分页查询库存流水
 * @param {Object} params 查询库存流水参数
 * @param {string} [params.barcode] 商品条码
 * @param {number} [params.goodsId] 商品ID
 * @param {string} [params.bizType] 业务类型
 * @param {number} [params.operator] 操作人
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var inventoryTransactions = exports.inventoryTransactions = function inventoryTransactions(params) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/log/list"),
    method: 'GET',
    params: params
  });
};

/**
 * 执行拆箱
 * @param {Object} data 拆箱参数
 * @param {string} data.parentBarcode 主商品条码
 * @param {number} data.parentGoodsId 主商品ID
 * @param {string} data.parentName 主商品名称
 * @param {number} data.operator 操作人
 * @param {number} data.unpackQty 拆箱数量
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var boxSplitting = exports.boxSplitting = function boxSplitting(data) {
  return (0, _request.default)({
    url: "".concat(STOCK_BASE_URL, "/unpack"),
    method: 'POST',
    data: data
  });
};

/**
 * @typedef {0|1} status
 * 盘库状态：
 * 0 - 待处理
 * 1 - 已完成
 */
/**
 * 分页查询盘库单
 * @param {Object} params 查询参数
 * @param {string} [params.checkNo] 盘库单号
 * @param {number} [params.status] 盘库状态
 * @param {number} [params.operator] 操作人
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var getInventoryCountingList = exports.getInventoryCountingList = function getInventoryCountingList(params) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/list"),
    method: 'GET',
    params: params
  });
};

/**
 * 创建盘库单
 * @param {Object} data 创建盘库单参数
 * @param {Array<number>} data.goodsIds 盘库商品ID列表
 * @param {number} data.operator 操作人
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var createInventoryCounting = exports.createInventoryCounting = function createInventoryCounting(data) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/save"),
    method: 'POST',
    data: data
  });
};

/**
 * 分页查询盘库明细
 * @param {Object} params 查询参数
 * @param {string} [params.barcode] 商品条码
 * @param {number} [params.checkId] 盘库单ID
 * @param {number} [params.goodsId] 商品ID
 * @param {string} [params.name] 商品名称
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var getInventoryCountingRecords = exports.getInventoryCountingRecords = function getInventoryCountingRecords(params) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/detail/list"),
    method: 'GET',
    params: params
  });
};

/**
 * 更新盘库明细
 * @param {Object} data 更新盘库明细参数
 * @param {number} data.actualQty 盘库商品ID
 * @param {number} data.detailId 盘库明细ID
 * @param {string} data.remark 备注信息
 * @returns {Promise<object>}
 */
var updateInventoryCounting = exports.updateInventoryCounting = function updateInventoryCounting(data) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/detail/update"),
    method: 'POST',
    data: data
  });
};

/**
 * 删除盘库明细商品
 * @param {number} id 明细ID
 * @returns {Promise<object>}
 */
var deleteInventoryCountingGoods = exports.deleteInventoryCountingGoods = function deleteInventoryCountingGoods(id) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/detail/delete?id=").concat(id),
    method: 'GET'
  });
};

/**
 * 确认盘库单
 * @param {number} checkId 盘库单ID
 * @returns {Promise<object>}
 */
var confirmInventoryCounting = exports.confirmInventoryCounting = function confirmInventoryCounting(checkId) {
  return (0, _request.default)({
    url: "".concat(COUNTING_BASE_URL, "/confirm?checkId=").concat(checkId),
    method: 'GET'
  });
};